import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { startSubmission, loadSubmission } from '../actions';

const mapStateToProps = state => ({
  submission: state.submission,
});

const mapDispatchToProp = dispatch => ({
  onSubmit: (name) => {
    dispatch(startSubmission(name));
  },

  onLoad: () => {
    dispatch(loadSubmission());
  }
});

class GuestName extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: null,
    }
    this.onChangeName = this.onChangeName.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentWillMount() {
    this.props.onLoad();
  }

  onChangeName(name) {
    this.setState({ name });
  }

  onSubmit() {
    let { name } = this.state;
    name = name.trim()
    if (name && name.length) {
      this.props.onSubmit(name);
    }
  }

  render() {
    const { submission } = this.props;
    const { name } = this.state;

    const displayName = name || get(submission, 'name', '');

    const nameHTML = !submission ? (
      <div className="control-group">
        <input type="text" name="name" value={ displayName } className="input-xlarge" maxLength="200" placeholder="Your Name" 
          onChange={(e) => this.onChangeName(e.target.value)}/>
      </div>
    ) : (<h3>{ displayName }</h3>);

    const submitButton = !submission ? (
      <button className="btn btn-primary btn-large" type="submit" onClick={ this.onSubmit }>
          START <i className="fa fa-chevron-circle-right" aria-hidden="true" />
      </button>
    ) : null;

    return (
      <div>
        { nameHTML }
        { submitButton }
      </div>
    );
  }
}

GuestName.propTypes = {
  submission: PropTypes.object,
  onLoad: PropTypes.func,
  onSubmit: PropTypes.func,
};

const GuestNameContainer = connect(
  mapStateToProps,
  mapDispatchToProp
)(GuestName);

export default GuestNameContainer;


// WEBPACK FOOTER //
// ./src/components/GuestName.js